<template>
  <div class="introduction-content1">
    <div class="title-container">
      <div class="title-text">公司概况</div>
      <div class="title-text-en">Company Profile</div>
    </div>
    <div class="content-container">
      <div class="company-image">
        <img src="@/assets/image/login-logo.png" alt="company logo" />
      </div>
      <div class="intro-list">
        <div
          v-for="(intro, index) in introList"
          :key="index"
          class="intro-item"
        >
          {{ intro }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroductionContent1',
  data() {
    return {
      introList: [
        '上海嗨喵网络科技有限公司是一家以互联网技术为核心的创新性企业，公司采用先进的前后端技术与严谨的管理制度，坚持以“让客户满意，为客户创造价值”为服务宗旨。',
        '主要从事大屏幕互动服务平台的提供、支持与定制；App定制与开发；行业软件定制与开发；微信公众号、小程序、桌面程序开发等。',
        '公司拥有完整、专业的研发、产品、运营、客服、市场等团队，随着互联网的发展与普及，越来越多的主办方使用互联网技术手段来举行现场活动、组织会议。上海嗨喵网络科技有限公司凭借丰富的运营经验，借助强大的技术开发实力，为您提供全面的优质服务。',
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.introduction-content1 {
  width: 100%;
  height: auto;
  margin-top: 68px;
  
  .title-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    
    .title-text {
      font-weight: 700;
      font-size: 32px;
      line-height: 1;
      background: linear-gradient(to bottom, #CA5EFB 46%, #844DFE 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    
    .title-text-en {
      font-weight: 500;
      font-size: 18px;
      line-height: 1.5;
      background: linear-gradient(to bottom, #CA5EFB 46%, #844DFE 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      margin-top: 12px;
    }
  }
  
  .content-container {
    margin-top: 48px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    gap: 52px;
    
    .company-image {
      width: 415px;
      height: 317px;
      background: linear-gradient(180deg, #E29DFF 0%, #A287FF 100%);
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      
      img {
        width: 200px;
        height: auto;
      }
    }
    
    .intro-list {
      display: flex;
      flex-direction: column;
      gap: 21px;
      width: 680px;
      
      .intro-item {
        position: relative;
        padding-left: 24px;
        font-weight: 500;
        font-size: 18px;
        line-height: 30px;
        color: #FFFFFF;
        word-wrap: break-word;
        word-break: break-all;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 7.5px;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background-color: #FFFFFF;
        }
      }
    }
  }
}
</style>
